import React from 'react';
import PropTypes from 'prop-types';
import Slide from './Slide';
import { SLIDE_GAP } from './constants';

export default function SlideList({
  slides,
  state,
  slideRefs,
  isScrollAllowed,
  slidesToShow,
  containerWidth,
  minimumSlideWidth,
  onSlideInteraction,
}) {
  const getIsActive = (index) => isScrollAllowed && index === state.index;

  const getIsHidden = (index) => {
    if (!isScrollAllowed) return false;

    if (slidesToShow && slidesToShow > 0) {
      return index < state.index || index >= state.index + slidesToShow;
    }

    return !getIsActive(index);
  };

  const calculateSlideWidth = () => {
    if (!slidesToShow || slidesToShow <= 0 || containerWidth <= 0) {
      return undefined;
    }

    const totalGaps = slidesToShow - 1;
    const availableWidth = containerWidth - (totalGaps * SLIDE_GAP);
    const minWidthNeeded = minimumSlideWidth || 0;
    const baseWidth = Math.max(Math.floor(availableWidth / slidesToShow), minWidthNeeded);

    return baseWidth;
  };

  return slides?.map((slide, index) => {
    const isActive = getIsActive(index);
    const isHidden = getIsHidden(index);
    const calculatedWidth = calculateSlideWidth();

    const slideKey = slide?.props?.id || slide?.key || `slide-${index}`;

    return (
      <Slide
        key={slideKey}
        // eslint-disable-next-line no-param-reassign
        ref={(el) => { slideRefs.current[index] = el; }}
        isActive={isActive}
        isHidden={isHidden}
        isScrollAllowed={isScrollAllowed}
        minWidth={minimumSlideWidth}
        width={calculatedWidth}
        onMouseDown={onSlideInteraction.onMouseDown}
        onMouseUp={onSlideInteraction.onMouseUp}
        onTouchEnd={onSlideInteraction.onTouchEnd}
        onTouchStart={onSlideInteraction.onTouchStart}
      >
        {slide}
      </Slide>
    );
  }) || null;
}

SlideList.propTypes = {
  slides: PropTypes.arrayOf(PropTypes.node).isRequired,
  state: PropTypes.shape({
    index: PropTypes.number.isRequired,
  }).isRequired,
  slideRefs: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({})]),
  isScrollAllowed: PropTypes.bool.isRequired,
  slidesToShow: PropTypes.number,
  containerWidth: PropTypes.number.isRequired,
  minimumSlideWidth: PropTypes.number,
  onSlideInteraction: PropTypes.shape({
    onMouseDown: PropTypes.func,
    onMouseUp: PropTypes.func,
    onTouchEnd: PropTypes.func,
    onTouchStart: PropTypes.func,
  }).isRequired,
};
